import { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Card } from "antd";
import { req_list_rts_course_student_weeklog } from "../../api";
import { usrRole } from "../../utils/dataUtil";
class CourseStudentOneWeekLogModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };
  state = {
    loading: false,
    lock: false,
    data: [],
    academicCredit: 0,
    threshold: 0,
  };

  componentDidMount() {
    this.api_item_list();
  }

  api_item_list = async () => {
    const { OpenCourseSerialKey,  AcademicSemeter, AcademicYear, AcademicCredit, AcademicWeekNum } = this.props.data;
    const { token, role, userCode } = this.props.user;
    //console.log(this.props.data);

    var userLevel = usrRole(role);
    this.setState({
      loading: true,
      academicCredit: AcademicCredit,
      threshold: AcademicCredit * 60,
    });
    const result = await req_list_rts_course_student_weeklog(
      userLevel,
      userCode,
      AcademicYear,
      AcademicSemeter,
      OpenCourseSerialKey,
      AcademicWeekNum,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      console.log(items);
      this.setState({
        data: items,
        loading: false,
      });
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  render() {
    const {
      AcademicYear,
      AcademicSemeter,
      ClassroomName,
      CourseName,
      AcademicWeekNum
    } = this.props.data;
    const { data, loading, threshold } = this.state;
    const columns = [
      {
        title: "學號",
        dataIndex: "StudentId",
        key: "StudentId",
        render: (text) => <>{text}</>,
      },
      {
        title: "學生",
        dataIndex: "StudentName",
        key: "StudentName",
        render: (text) => <>{text}</>,
      },
      {
        title: "學習時數",
        dataIndex: "StayMinuteTotal",
        key: "StayMinuteTotal",
        render: (text) => (
          <>
            <span
              style={
                threshold > text
                  ? { color: "red", fontWeight: "bold" }
                  : { color: "green", fontWeight: "bold" }
              }
            >
              {text}分鐘
            </span>
          </>
        ),
      },
    ];
    return (
      <Card>
        <h3>
          {" "}
          {AcademicYear}-{AcademicSemeter} {ClassroomName}/{CourseName} <span style={{ color: "red" }}>第{AcademicWeekNum}週</span>
        </h3>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
          scroll={{
            y: 55 * 5,
          }}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CourseStudentOneWeekLogModal);
